import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import {
  FOR,
  NO_RESULT_FOUND,
  SEARCHING_FOR_LINES,
} from 'src/app/modules/route-planner/constants/multi-language.constants';

@Component({
    selector: 'app-no-results',
    templateUrl: './no-results.component.html',
    styleUrls: ['./no-results.component.scss'],
    standalone: false
})
export class NoResultsComponent implements OnInit {
  @Input() noResultsForWhatText: string;

  noResultText: string;
  forText: string;
  searchingForLinesText: string;
  isSearchingFromSharedLink: boolean = false;

  constructor(
    private readonly languageService: LanguageService,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.initializeMultiLanguageTexts();
    this.checkIfSearchingFromSharedLink();
  }

  checkIfSearchingFromSharedLink() {
    this.route.queryParams.subscribe((params) => {
      // Check if saveParams exists and is not null/undefined
      // It could be 'true', true, or any other value
      this.isSearchingFromSharedLink =
        params['saveParams'] !== undefined && params['saveParams'] !== null;
    });
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.noResultText = NO_RESULT_FOUND[language.language];
      this.forText = FOR[language.language];
     this.searchingForLinesText =
     NO_RESULT_FOUND[language.language];
    });
  }
}
